module.exports = __webpack_public_path__ + "img/pw.c8788802.svg";